import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/fixel.js');
require('./js/helpers.js');
require('./js/accordion.js');
require('./js/countdown.js');
require('./js/cookies.js');
require('./js/init.js');
require('./js/inview.js');
require('./js/ismobile.js');
require('./js/lazy.js');
require('./js/nav.js');
require('./js/scrollpos.js');
require('./js/smoothscroll.js');
